module.exports = {
	"Search the video": "Procurar no vídeo",
	"Explore": "Explorar",
	"Print": "Imprimir",
	"Download": "Baixar",
	"Share": "Compartilhar",
	"Settings": "Configurações",
	"Language": "Idioma",
	"Interface Language": "Idioma da interface",
	"Transcript / Captions Language": "Transcrição / Idioma da legenda",
	"Transcript Language": "Idioma da transcrição",
	"Captions Language": "Idioma da legenda",
	"Show Transcript": "Exibir transcrição",
	"Show Captions": "Exibir legendas",
	"Show Heatmap": "Exibir mapas de calor",
	"Show Speakers in Transcript": "Exibir interlocutor na transcrição",
	"Keyword": "Palavra-chave",
	"Keywords": "Palavras-chave",
	"Topic": "Tópico",
	"Topics": "Tópicos",
	"Speaker": "Interlocutor",
	"Speakers": "Interlocutores",
	"Transcript": "Transcrição",
	"Previous": "Anterior",
	"Next": "Seguinte",
	"Clear": "Limpar",
	"No results found": "Nenhum resultado encontrado",
	"try another search or explore": "tente outra procura ou explore",
	"Share Search": "Compartilhar Pesquisa",
	"Share Time": "Compartilhar Tempo",
	"There is no transcript available in the selected language.": "Não há transcrição disponível na linguagem selecionada.",
	"Show {{count}} more": "Mostrar mais {{count}}",
	"Show {{count}} more_plural": "Mostrar mais {{count}}"
};


//////////////////
// WEBPACK FOOTER
// ./locale/pt.json
// module id = ./locale/pt.json
// module chunks = 0 1